import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import avatar from 'assets/img/avatars/avatarSimmmple.png';
import { Agent } from 'types';
import { Link } from 'react-router-dom';
import { Image } from 'components/Image';
import Dropdown from 'components/dropdown';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useDeleteConversation } from 'layouts/agent/agent-chat/hooks/useDeleteConversation';
import { useConfirmation } from 'components/dialog/confirmation';

export const ChatHeader: React.FC<{
  onClose: () => void;
  isLoading: boolean;
  currentAgent: Agent | null;
  onRetry: () => void;
  open: boolean;
  conversationId?: string;
  agentId?: string;
}> = ({ onClose, open, currentAgent, conversationId, agentId }) => {
  const { deleteConversation, isLoading: isDeleting } =
    useDeleteConversation();
  const { confirm } = useConfirmation();
  const handleDelete = async () => {
    if (conversationId && agentId) {
      const isConfirmed = await confirm({
        title: 'Delete Conversation',
        message: 'Are you sure you want to delete this conversation?',
        confirmText: 'Delete',
        variant: 'danger',
      });
      if (isConfirmed) {
        deleteConversation(conversationId, agentId);
      }
    }
  };
  return (
    <div className="mb-auto flex items-center justify-between border-b border-gray-200 pb-3 dark:!border-gray-700">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={onClose}
            className="block cursor-pointer rounded-full p-1 transition hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-200 lg:hidden"
          >
            {open ? (
              <MdChevronLeft className="h-5 w-5 text-gray-600" />
            ) : (
              <MdChevronRight className="h-5 w-5 text-gray-600" />
            )}
          </button>
          <Image
            alt={currentAgent?.name}
            src={currentAgent?.icon_uri}
            fallbackSrc={avatar}
            className="h-10 w-10 rounded-full object-cover"
          />
        </div>
        <div>
          <h1 className="font-sans text-[20px] font-bold text-gray-800 dark:text-white">
            {currentAgent?.name}
          </h1>
        </div>
      </div>
      <Dropdown
        button={
          <button className="flex items-center justify-center rounded-full bg-gray-100 p-2 text-gray-600 transition hover:bg-gray-200">
            <BsThreeDotsVertical className="h-5 w-5" />
          </button>
        }
        classNames={'py-2 top-8 right-0 w-max'}
      >
        <div className="flex w-full flex-col gap-2 rounded-md bg-white p-2 text-sm font-medium text-gray-800 shadow-md dark:!bg-navy-700 dark:text-white">
          <Link
            to={`/dashboard/agents/info/${currentAgent?.id}`}
            className="w-full rounded-md px-3 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-600"
          >
            View Agent
          </Link>
          <button
            onClick={handleDelete}
            disabled={isDeleting || !conversationId}
            className="w-full rounded-md px-3 py-2 text-left text-red-500 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-gray-600"
          >
            {isDeleting ? 'Deleting...' : 'Delete Conversation'}
          </button>
        </div>
      </Dropdown>
    </div>
  );
};
